// src/features/evaluation/hooks/useEvaluationSession.js

import { useState, useCallback } from "react";
import axios from "axios";

export default function useEvaluationSession({ apiUrl, token }) {

  const [session, setSession] = useState(null);
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const startSession = useCallback(async (
    payload,
    {
      sessionPath = "/evaluation/session/get-or-create"
    } = {}
  ) => {

    try {

      setLoading(true);
      setError("");

      const res = await axios.post(
        `${apiUrl}${sessionPath}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const sessionData = res.data.session;

      setSession(sessionData);
      setResponses(res.data.responses || []);
      return sessionData;

    } catch (err) {

      console.error("❌ Session start error", err);
      setError("Could not start the evaluation session.");
      return null;

    } finally {
      setLoading(false);
    }

  }, [apiUrl, token]);

  const clearSession = useCallback(() => {
    setSession(null);
    setResponses([]);
    setError("");
  }, []);

  return {
    session,
    responses,
    loading,
    error,
    startSession,
    clearSession
  };
}
